var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"scale-fade-transition","mode":"out-in"}},[(!_vm.isRun)?_vm._t("form"):_c('div',_vm._b({},'div',_vm.$attrs,false),[_vm._t("report")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }